module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('settings.main.payment_data')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings.main.enter_bank_details')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings.main.set_up_billet')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings.main.select_bank')))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-215b2d09"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/components/FormDescription.vue
// module id = 742
// module chunks = 1